module.exports = __webpack_public_path__ + "img/tn_verified_by_visa.cc8a364a.png";